import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { log } from './utils/logger'

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTHDOMAIN,
  measurementID: process.env.REACT_APP_MEASUREMENTID,
  projectId: process.env.REACT_APP_PROJECTID,
  storageBucket: process.env.REACT_APP_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_APPID
}

log.debug(`Initializing Firebase`)
const app = initializeApp(firebaseConfig)

const auth = getAuth(app)
auth.authStateReady().then(() => log.debug(`App Ready!`))
export { auth }
